/* import __COLOCATED_TEMPLATE__ from './transfer-instrument-row.hbs'; */
import Component from '@glimmer/component';
export default class TransferInstrumentRowComponent extends Component {}